{
  "version": 1,
  "asset_id": "8c532e2b-f4da-4b1a-aeff-420277a6ccb4",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/8c532e2b-f4da-4b1a-aeff-420277a6ccb4/smartlane-rudolph-2.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/8c532e2b-f4da-4b1a-aeff-420277a6ccb4/smartlane-rudolph-2.png",
  "original_filename": "smartlane-rudolph-2.png",
  "size": 1802224,
  "content_type": "image/png",
  "created_at": "2026-10-08T11:25:21Z"
}
